import React, { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import payaPaymentSaga from '../../../../redux/healthboard/sagas/paya-payment-saga';
import { RESTART_ON_REMOUNT } from '../../../../redux/sagaInjectors';
import { useInjectSaga } from '../../../../redux/injectSaga';
import BackButton from '../../../common/BackButton';
import Loader from '../../../common/Loader';
import styles from './styles.styl';

const HEADER_HEIGHT = 56;

function PayaPayment({ options: { url }, onClose }) {
  useInjectSaga({
    key: 'payaPaymentSaga',
    saga: payaPaymentSaga,
    mode: RESTART_ON_REMOUNT,
  });

  const [height, setHeight] = useState();
  const [loading, setLoading] = useState(true);
  const finishLoading = () => setLoading(false);

  useEffect(() => {
    setHeight(window.innerHeight - HEADER_HEIGHT);
  }, []);

  return (
    <div styleName="root">
      <BackButton onBack={onClose} styleName="back-btn" minWidth={100} />

      <div styleName="header">
        <p styleName="header--title">
          <FormattedMessage id="appointment.payment.title" />
        </p>
      </div>

      <div styleName={cn('payment-view', { loading })}>
        {loading && <Loader />}

        <iframe
          src={url}
          height={height}
          onLoad={finishLoading}
          title="account-form"
        />
      </div>
    </div>
  );
}

PayaPayment.propTypes = {
  onClose: PropTypes.func,
  options: PropTypes.shape({
    url: PropTypes.string,
  }),
};

export default CSSModules(PayaPayment, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/PayaPayment/index.jsx